import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FaqItem" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['FaqQuestion', { 'is-opened': _ctx.isOpened }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.question) + " ", 1 /* TEXT */),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIconFaq", _ctx.isOpened ? 'lnr-chevron-up' : 'lnr-chevron-down'])
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createElementVNode("p", {
      innerHTML: _ctx.answer,
      class: _normalizeClass(['FaqAnswer', { Hidden: !_ctx.isOpened }])
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)
  ]))
}